<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="姓名/电话：">
            <el-input v-model="query.keyword" placeholder="请输入姓名或电话" clearable size="small" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">

      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" plain>新增</el-button>
          <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" border stripe style="width: 100%;">
        <el-table-column type="selection" width="50" />
        <el-table-column label="账号" prop="userName" align="center" />
        <el-table-column label="头像" prop="headImg" align="center">
          <template slot-scope="{row}">
            <el-image v-if="row.headImg" style="width: 50px; height: 50px" :src="row.headImg" :preview-src-list="[row.headImg]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="realName" align="center" />
        <!-- <el-table-column label="手机号" prop="userPho" align="center" /> -->
        <el-table-column label="角色" prop="userPho" align="center">
          <template slot-scope="{row}">
            <span v-for="(item,index) in row.sysRoleList" :key="index">{{item.roleName}}{{row.sysRoleList.length - 1 != index?',':''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="登录次数" prop="loginCount" align="center" />
        <el-table-column label="最近登录IP" prop="sysLoginLogPO.ip" align="center" />
        <el-table-column label="最近登录时间" prop="sysLoginLogPO.createdTime" align="center" />
        <el-table-column label="状态" prop="entryInhibited" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.entryInhibited" :active-value="0" :inactive-value="1" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" />
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
            <el-button type="text" @click="handleLoginLog(row,2)">登录日志</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <user-add ref="userAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import userAdd from './add'
import userApi from '@/api/system/user'
// import sysDeptApi from '@/api/sys/sysDept'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
    userAdd
  },
  data() {
    return {
      options: {
        sysDept: []
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    // sysDeptApi.findOptions().then(data => { this.options.sysDept = data })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.userType = 1
      this.listLoading = true
      return userApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => userApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择用户')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => userApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      userApi.updateEntryInhibited({ id: row.id, entryInhibited: row.entryInhibited }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.userAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.userAdd.handleUpdate(row)
    },
    handleLoginLog(row) {
      this.$emit('handleShow', row, 2)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=55&otherType=1&id=" + row.id);
    }
  }
}
</script>
